<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="4">
          <el-input placeholder="员工手机号" v-model="mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="4">
          <el-input placeholder="员工编号" v-model="staff_no" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6">
          <el-input placeholder="备注说明" v-model="memo" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-date-picker v-model="created" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-加盟员工奖金提现’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
          <el-upload style="display: inline;" action="" :on-change="uploadHandleChange" :auto-upload="false" :show-file-list="false" >
            <el-button size="mini" type="primary">加盟员工单提数据上传</el-button>
          </el-upload>
          <a type="primary" href="https://img1.yaoking.cn/000/%E5%8A%A0%E7%9B%9F%E5%91%98%E5%B7%A5%E5%8D%95%E6%8F%90%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xlsx">导入模板下载</a>
        </el-col>
      </el-row>

      <div class="recharge-overview view-flex content-center content-padded" style="width: 80%;">
        <div class="view-flex-item">
          <i class="iconfont icon-donate"></i>
          <div><span>总金额：</span> <span class="money mark">{{all_money}}</span> 元</div>
        </div>
        <!-- <div class="view-flex-item">
          <i class="iconfont icon-credit-card1"></i>
          <div>总条数：<span class="money mark">{{total_count}}</span> 条</div>
        </div> -->
        <div class="view-flex-item">
          <i class="iconfont icon-credit-card1"></i>
          <div>已处理金额汇总：<span class="money mark">{{processed_money}}</span> 元</div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-credit-card1"></i>
          <div>待处理金额汇总：<span class="money mark">{{not_processed_money}}</span> 元</div>
        </div>
      </div>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-table :data="withdrawData" :height="wheight-210"  v-loading="loading">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="log_id" label="编号" width="100"></el-table-column>
        <el-table-column prop="staff_no" label="员工编号" width="120"></el-table-column>
        <el-table-column prop="mobile"   label="员工手机号" width="140"></el-table-column>
        <el-table-column prop="name"  label="员工姓名" width="100"></el-table-column>
        <el-table-column prop="money"  label="单提金额" width="100"></el-table-column>
        <el-table-column prop="status_str" label="状态" width="120">
            <template slot-scope="scope">
              <!-- 订单状态 -->
              <el-tag v-if="scope.row.status == 0" size="mini">待处理</el-tag>
              <el-tag v-else-if="scope.row.status == 1" type="success" size="mini">已处理</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="created_at" label="申请时间" width="200">
          <template slot-scope="scope">
            {{scope.row.created_at | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="处理时间" width="200">
          <template slot-scope="scope" v-if="scope.row.updated_at">
            {{scope.row.updated_at | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="memo"  label="说明" width="280"></el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {
  franchiseStafftixianList,
  franchiseStafftixianExport,
  franchiseStafftixianUploadFile
} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      id: [],
      total_count: 0,
      loading: false,
      exportLoading: false,
      btnLoading: false,
      withdrawData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      mobile: '',
      staff_no: '',
      memo: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    // 加盟员工单提数据上传
    uploadHandleChange (file, fileList) {
      let paramz = {isUploadFile: true, file: file.raw}
      console.log(paramz)
      franchiseStafftixianUploadFile(paramz).then(response => {
        this.getStafftixianList(this.params)
        if (response.data.data.status) {
          let count = response.data.data.count
          let current_total_money = response.data.data.current_total_money
          this.$message({
            type: 'success',
            showClose: true,
            message: '上传成功，本次共新增' + count + '条数据，本次单提金额合计共 ' + current_total_money + ' 元',
            duration: 60000, // 60 秒后关闭消息提示
          })
        } else {
          this.$message({
            type: 'error',
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '<p style="word-break: break-all;word-wrap: break-word;line-height: 32px;">' + response.data.data.message + '</p>',
            duration: 60000, // 60 秒后关闭消息提示
          })
        }
      })
    },
    // 获取加盟员工单提数据列表
    getStafftixianList (filter) {
      this.loading = true
      franchiseStafftixianList(filter).then(response => {
        this.withdrawData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.all_money = response.data.data.all_money
        this.processed_money = response.data.data.processed_money
        this.not_processed_money= response.data.data.not_processed_money
        this.loading = false
        this.exportLoading = false
      })
    },
    getParams () {
      this.params.mobile = this.mobile
      this.params.staff_no = this.staff_no
      this.params.memo = this.memo
    },
    // 按日期检索
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getStafftixianList(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    // 搜索
    keywordsSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getStafftixianList(this.params)
    },
    // 加盟员工单提数据导出
    exportData () {
      this.getParams()
      this.exportLoading = true
      franchiseStafftixianExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-加盟员工单提奖励'
          })
          return
        } else if (response.data.data.url) {
          this.downloadUrl = response.data.data.url
          this.downloadName = response.data.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '暂无数据可导出或导出执行失败，请检查重试'
          })
          return
        }
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getStafftixianList(this.params)
    }
  },
  mounted () {
    this.getStafftixianList(this.params)
  },
  watch: {
    // 分页全选-监听数据变化
    withdrawData: {
      handler (value) {
        if (this.allCheck) {
          this.withdrawData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}
.recharge-overview {
  .iconfont {
    font-size: 30px;
    color: #ff5000;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?743f0f9b